import { modalComponentModule } from '../../../../shared/app/components/modal/modal';
import changeLanguageDialogTemplate from './change-language-dialog.tpl.html';
import './change-language-dialog.less';
import { languages } from '../../../../shared/app/constants/languages';

export const changeLanguageComponentModule = angular
  .module('Q.components.change-language-dialog', [modalComponentModule])

  .factory('changeLanguageDialog', function changeLanguageDialog($modal, $q) {
    return {
      open(solution, languageIds, switchLanguageFn) {
        if (!solution) return $q.reject();
        return $modal.openOnce('changeLanguageDialog', {
          template: changeLanguageDialogTemplate,
          controller: 'ChangeLanguageDialogCtrl as $ctrl',
          resolve: {
            solution: () => solution,
            languageIds: () => languageIds,
            switchLanguageFn: () => switchLanguageFn,
          },
        }).result;
      },
    };
  })
  .controller(
    'ChangeLanguageDialogCtrl',
    function ChangeLanguageDialogCtrl(
      $modalInstance,
      solution,
      languageIds,
      switchLanguageFn,
    ) {
      const ctrl = this;

      ctrl.testCasesEnabled = solution.sampleTestCasesEnabled;

      const currentLanguage = (ctrl.currentLanguage = solution.language);
      ctrl.currentLanguageIds = [currentLanguage];
      ctrl.languageIds = languageIds
        .slice()
        .filter((lid) => lid !== currentLanguage);
      ctrl.newLanguage = [];

      ctrl.langChanged = () => ctrl.newLanguage[0];

      ctrl.languageName = languages.toName;

      ctrl.changeButtonText = () => {
        return ctrl.langChanged()
          ? `Switch to solving in ${languages.toName(ctrl.newLanguage)}`
          : `Choose a new language from above`;
      };

      ctrl.cancel = () => $modalInstance.dismiss();

      ctrl.change = () => {
        ctrl.processing = true;
        switchLanguageFn(ctrl.newLanguage[0])
          .then(ctrl.cancel)
          .catch(() => {
            ctrl.processing = false;
          });
      };
    },
  );
